export default __webpack_public_path__ + "0fcb6f4.png";